import { useState, useEffect, useCallback } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { Input, Table, Button, InputNumber } from "antd";
import { ListarProcedimientoConPrecios } from "../../../Service/Service.examen";
import Swal from "sweetalert2";

function ModalSeleccionarExamenEditar({ show, handleClose, agregarExamenes, seguroId, examenesActuales }) {
    const [procedimientos, setProcedimientos] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedProcedimientos, setSelectedProcedimientos] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);

    // TARIFARIOS-PERF-02: la aseguradora la filtra el SERVIDOR (antes se
    // bajaban las 19 y se descartaban 18 en el navegador). La segunda
    // condicion -- excluir los examenes que la promocion YA tiene -- se queda
    // aqui a proposito: depende de lo que el usuario tiene en pantalla, no de
    // nada que el servidor pueda saber.
    const fetchProcedimientos = useCallback(async () => {
        setLoading(true);
        const response = await ListarProcedimientoConPrecios({ seguro_id: seguroId });
        if (response.success) {
            const procedimientosFiltrados = (response.data || []).filter(
                proc => !examenesActuales.some(ex => ex.id_tipo_examen === proc.idExamenTipo)
            );
            setProcedimientos(procedimientosFiltrados);
        }
        setLoading(false);
    }, [seguroId, examenesActuales]);

    useEffect(() => {
        if (show) {
            fetchProcedimientos();
        }
    }, [show, fetchProcedimientos]);

    const handleAgregar = () => {
        if (selectedProcedimientos.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Advertencia",
                text: "Debe seleccionar al menos un examen",
            });
            return;
        }
    
        agregarExamenes(selectedProcedimientos.map(proc => ({
            id_tipo_examen: proc.idExamenTipo,
            ExamenTipo: {
                codigo: proc.ExamenTipo.codigo,
                descripcion: proc.ExamenTipo.descripcion
            },
            tarifario: {
                precio: proc.precio,
                idprocedimiento_company_precios: proc.idprocedimiento_company_precios, // 🔥 AÑADIDO
            },
            precio_promocion: proc.precio_promocion ?? proc.precio
        })));
    
        Swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: `${selectedProcedimientos.length} examen(es) agregado(s) exitosamente.`,
            timer: 1500,
            showConfirmButton: false,
        });
    
        setSelectedRowKeys([]);
        setSelectedProcedimientos([]);
        handleClose();
    };
    

    const handleSearch = (value) => {
        setSearchText(value);
    };

    const onRowSelectionChange = (selectedKeys, selectedRows) => {
        setSelectedRowKeys(selectedKeys);
        setSelectedProcedimientos(selectedRows.map(row => ({
            ...row,
            precio_promocion: row.precio_promocion ?? row.precio
        })));
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onRowSelectionChange,
        preserveSelectedRowKeys: true,
    };

    const filteredProcedimientos = procedimientos.filter(proc =>
        proc.ExamenTipo.codigo.toLowerCase().includes(searchText.toLowerCase()) ||
        proc.ExamenTipo.descripcion.toLowerCase().includes(searchText.toLowerCase())
    );

    const columns = [
        {
            title: 'Código',
            dataIndex: ['ExamenTipo', 'codigo'],
            key: 'codigo',
            width: 100,
        },
        {
            title: 'Descripción',
            dataIndex: ['ExamenTipo', 'descripcion'],
            key: 'descripcion',
            width: 250,
        },
        {
            title: 'Precio',
            dataIndex: 'precio',
            key: 'precio',
            align: 'right',
            render: (precio) => `$${precio.toFixed(2)}`,
            width: 100,
        },
    ];

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Seleccionar Exámenes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-2">
                    <Col>
                        <Input
                            placeholder="Buscar por código o descripción"
                            value={searchText}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </Col>
                </Row>

                <Table
                    dataSource={filteredProcedimientos}
                    columns={columns}
                    size="small"
                    scroll={{ x: "max-content", y: 300 }}
                    rowKey={(record) => record.idprocedimiento_company_precios}
                    rowSelection={rowSelection}
                    loading={loading}
                    pagination={{ pageSize: 5 }}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button type="primary" onClick={handleAgregar}>
                    Agregar Seleccionados
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalSeleccionarExamenEditar;
